import React from 'react'
import TextField from '../../../baseApp/shared/components/fields/textField/TextField';
import { I18n } from 'react-redux-i18n';
import SelectField from "../../../baseApp/shared/components/fields/selectField/SelectField";
import Alert from '../../../baseApp/shared/components/alerts/Alert';
import FormButtons from "../../../baseApp/shared/components/others/formButtons/FormButtons";
import PasswordFieldContainer from "../../../baseApp/shared/components/fields/passwordField/PasswordFieldContainer";
import { appModules } from '../../../baseApp/roles/components/UserHasPermission';

const ConsoleUsersForm = ({
    consoleUserFormData: {
        username,
        password,
        confirmPassword,
        entity,
        numberOfConnections,
        active,
        properties: {
            consoleSettingsPIN,
            maxNumberOfConnections
        },
    },
    lastCommunication,
    alert,
    editMode,
    createMode,
    viewMode,
    entityList,
    handleFieldChange,
    handlePropertyFieldChange,
    handleOnFieldBlur,
    handleSubmitClick,
    handleBackClick,
    handleEditClick,
    handleDeleteClick,
}) => {
    return <div className="form-container">
        <div className="form">
            <Alert
                {...alert}
            />
            <div className="header">
                {buildHeader(createMode, editMode, viewMode)}
            </div>
            <div className="fields">
                <div id="console-user-fields-1" className="row">
                    <TextField
                        value={username.value}
                        label={I18n.t('consoleUser.form.userName.label')}
                        handleFieldChange={value => handleFieldChange("username", value)}
                        handleFieldBlur={() => handleOnFieldBlur("username", false)}
                        themeName="form"
                        error={username.error}
                        disabled={viewMode || editMode}
                        width={4}
                    />
                    <SelectField
                        handleFieldChange={value => handleFieldChange("entity", value)}
                        handleFieldBlur={() => handleOnFieldBlur("entity", false)}
                        value={entity.value}
                        label={I18n.t('consoleUser.form.entity.label')}
                        options={entityList}
                        error={entity.error}
                        disabled={viewMode}
                        width={4}
                    />
                </div>
                {buildPasswordFields(viewMode, password, confirmPassword, handleFieldChange, handleOnFieldBlur)}
                <div id="console-user-fields-3" className="row">
                    <TextField
                        value={consoleSettingsPIN.value}
                        label={I18n.t('consoleUser.form.consoleSettingsPIN.label')}
                        handleFieldChange={value => handlePropertyFieldChange("consoleSettingsPIN", value)}
                        handleFieldBlur={() => handleOnFieldBlur("consoleSettingsPIN", true)}
                        themeName="form"
                        error={consoleSettingsPIN.error}
                        disabled={viewMode}
                        width={4}
                    />
                    <TextField
                        value={maxNumberOfConnections.value}
                        label={I18n.t('consoleUser.form.maxNumberOfConnections.label')}
                        handleFieldChange={value => handlePropertyFieldChange("maxNumberOfConnections", value)}
                        handleFieldBlur={() => handleOnFieldBlur("maxNumberOfConnections", true)}
                        themeName="form"
                        error={maxNumberOfConnections.error}
                        disabled={viewMode}
                        width={4}
                    />
                </div>
                {buildConsoleUserView(active, numberOfConnections, lastCommunication, viewMode, editMode, handleFieldChange)}
            </div>
            {(createMode || editMode) &&
                <div className="buttons">
                    <button
                        className=" mt-3 btn btn-primary"
                        onClick={handleSubmitClick}
                    >
                        {I18n.t("forms.save")}
                    </button>
                </div>
            }
        </div>
        <div className="form-options">
            <FormButtons
                editMode={editMode}
                viewMode={viewMode}
                handleBackClick={handleBackClick}
                handleEditClick={handleEditClick}
                handleDeleteClick={handleDeleteClick}
                appModule={appModules.CONSOLE_USER}
            />
        </div>
    </div>
};

function buildPasswordFields(viewMode, password, confirmPassword, handleFieldChange, handleOnFieldBlur) {
    if (!viewMode) {
        return <div id="console-user-fields-2" className="row">
            <PasswordFieldContainer
                value={password.value}
                label={I18n.t('consoleUser.form.password.label')}
                handleFieldChange={value => handleFieldChange("password", value)}
                handleFieldBlur={() => handleOnFieldBlur("password", false)}
                themeName="form"
                error={password.error}
                disabled={viewMode}
                width={4}
            />
            <PasswordFieldContainer
                value={viewMode ? password.value : null}
                label={I18n.t('consoleUser.form.confirmPassword.label')}
                handleFieldChange={value => handleFieldChange("confirmPassword", value)}
                handleFieldBlur={() => handleOnFieldBlur("confirmPassword", false)}
                showPassword={!viewMode}
                themeName="form"
                error={confirmPassword.error}
                disabled={viewMode}
                width={4}
            />
        </div>
    }
}

function buildConsoleUserView(active, numberOfConnections, lastCommunication, viewMode, editMode, handleFieldChange) {
    let status = active.value ? I18n.t('consoleUser.form.status.active') : I18n.t('consoleUser.form.status.inactive');
    if (viewMode || editMode) {
        return <React.Fragment>
            <div id="console-user-fields-4" className="row">
                <TextField
                    value={numberOfConnections.value}
                    label={I18n.t('consoleUser.form.numberOfConnections.label')}
                    themeName="form"
                    handleFieldChange={value => handleFieldChange("numberOfConnections", value)}
                    disabled={true}
                    width={4}
                />
                <TextField
                    value={status}
                    label={I18n.t('consoleUser.form.status.label')}
                    handleFieldChange={value => handleFieldChange("active", value)}
                    themeName="form"
                    disabled={true}
                    width={4}
                />
            </div>
            <div id="console-user-fields-5" className="row">
                <TextField
                    value={lastCommunication}
                    label={I18n.t('consoleUser.form.lastCommunication.label')}
                    handleFieldChange={value => handleFieldChange("lastCommunication", value)}
                    themeName="form"
                    disabled={true}
                    width={4}
                />
            </div>
        </React.Fragment>
    } else {
        return null;
    }
}

function buildHeader(createMode, editMode) {
    return createMode ?
        I18n.t('consoleUser.form.headers.create') :
        editMode ?
            I18n.t('consoleUser.form.headers.edit') :
            I18n.t('consoleUser.form.headers.view');
}

export default ConsoleUsersForm;